<template>
  <a-modal
    v-model="visible"
    title="线路报价导入"
    width="800px"
    ok-text="提交"
    class="import-plan-modal"
    :mask-closable="false"
    @cancel="onCancel"
    @ok="onSubmit"
  >
    <a-alert message="相同线路车型报价会覆盖现有的报价信息，请仔细核对好后进行导入" banner />
    <block-title
      title="下载模板"
      class="block"
      :show-line="false"
    >
      <div class="batchBtnStyle batch-file" @click="downloadTemplate">
        <div>
          <img class="icon-xlsx" src="@/assets/img/icon/icon_xlsx.png" />
          线路报价导入模板
        </div>
        <img class="icon_load cursor" src="@/assets/img/icon/icon_download.png" />
      </div>
    </block-title>

    <block-title
      title="选择文件"
      class="block"
      :show-line="false"
    >
      <div class="item-content">
        <div class="content-upload">
          <a-upload
            :show-upload-list="false"
            :before-upload="beforeUpload"
          >
            <a-button class="uploadBtn" :disabled="uploading" type="primary">
              <img class="uploadStyle" src="@/assets/img/icon/upload.png" alt="">
              {{selectFileBtnTxt}}
              </a-button>
          </a-upload>
        </div>
        <p class="upload-tip">单次上传最大不超过10000条数据，文件大小最大不超过10M，文件格式支持xlsx</p>
        <div v-if="file" class="filename batch-file">
          <div>
            <img class="filenameLeft" src="@/assets/img/icon/icon_file.png" alt="">
            {{file.name}}
          </div>
          <img class="filenameRight cursor" src="@/assets/img/icon/icon_lajitong.png" alt="" @click="removeFile">
        </div>
      </div>
    </block-title>
  </a-modal>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import { getFileNameSuffix } from "@/utils/handleFile.js";

export default {
  name: 'ImportPlan',
  components: {
    BlockTitle
  },
  data() {
    return {
      visible: false,
      file: null,
      uploading: false,
      // 文件最大10M
      fileMaxSize: 1024 * 1024 * 10,
      // 文件类型暂时只支持 .xlsx
      fileTypeLimit: [".xlsx"],
      timer:null,
    }
  },
  computed: {
    selectFileBtnTxt() {
      return !this.file ? "选择文件" : "重新选择";
    },
  },
  methods: {
    beforeUpload(file) {
      this.file = file;
      this.validateFile(file);
      return false;
    },
    // 校验文件格式
    validateFile(file) {
      const { fileMaxSize, fileTypeLimit } = this;
      const fileSize = file.size;
      const fileType = getFileNameSuffix(file.name);
      if (!fileTypeLimit.includes(fileType)) {
        this.file = null;
        this.$message.error("文件格式仅支持xlsx");
        return;
      }
      if (fileSize > fileMaxSize) {
        this.file = null;
        this.$message.error("文件最大不超过10M");
      }
    },
    show() {
      this.visible = true
    },
    removeFile(){
      this.file = null
    },
    onCancel() {
      this.visible = false
      this.uploading = false
      this.file = null
    },
    onSubmit() {
      const { file } = this;
      if (!file) {
        this.$message.warning('请选择需要上传的文件')
        return
      }
      if(this.timer){
       return
      }
      this.timer = true
      const formData = new FormData();
      formData.append("file", file);
      this.uploading = true;
      try {
        this.$message.success('上传文件成功')
        this.uploading = false;
        this.visible = false
        this.timer=false
        this.$emit('cancel')
      } finally {
        this.uploading = false;
        setTimeout(() => {
          this.timer=false
        }, 3000);
      }
    },
    downloadTemplate() {
      console.log('downloadTemplate')
    },
  }
}
</script>

<style lang="less" scoped>
.import-plan-modal {
  ::v-deep .ant-modal-body {
    padding: 0 0 32px 0;
    .ant-alert-banner {
      background: #FFEFDE;
      .ant-alert-message {
        color: #FB9432;
      }
    }
  }
  .block {
    margin-top: 32px;
    > div {
      margin-left: 32px;
    }
    .batch-file {
      border-radius: 4px;
      width: 456px;
      height: 64px;
      padding: 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .batchBtnStyle {
      background: #F2FBF8;
      margin-bottom: 32px;
      .icon-xlsx {
        width: 46px;
        height: 46px;
        margin-right: 16px;
      }
      .icon_load {
        width: 24px;
        height: 24px;
      }
    }
    .item-content {
      .uploadBtn {
        width: 160px;
        height: 32px;
        background: #06B880;
        border-radius: 2px;
        .uploadStyle {
          margin-right: 12px;
        }
      }
      .upload-tip {
        margin-top: 16px;
        color: #A9ABAE;
      }
      .filename {
        margin-top: 32px;
        border: 1px solid #EBEDF0;
      }
    }
    .cursor {
      cursor: pointer;
    }
  }
}
</style>
